export const state = {
  upload: [],
}

export const getters = {
  allUploadFiles: (state) => state.upload,
}

export const mutations = {}

export const actions = {}
